import { ReportTotalTable } from "./ReportTotalTable";
import { ReportTable } from "./ReportTable";
import React, { Component } from "react";
import { loadCSS } from "fg-loadcss/src/loadCSS";
import classNames from "classnames";
import {
    Select,
    MenuItem,
    Card,
    Grid,
    CardContent,
    CardHeader,
    FormControl,
    Paper,
    Button,
    InputLabel
} from "@material-ui/core";
import { selectUserProfile } from "vrcore-dashboard/dist/Dashboard/Router/selectors";
import Typography from "@material-ui/core/Typography";
import { Bar } from "react-chartjs-2";
import DayPickerInput from "react-day-picker/DayPickerInput";
import { formatDate, parseDate } from "react-day-picker/moment";
import Moment from "moment";
import { connect } from "react-redux";
import Icon from "@material-ui/core/Icon";
import { withStyles } from "@material-ui/core/styles";
import {
    setDateFrom,
    setDateTo,
    getUsers,
    setReportType,
    getVehicles,
    getReportTitles,
    getTotalUserReports,
    setExcelReportType,
    getTotalJobPackReports,
    getExcelReportTypeLabels,
    getExcelDoc
} from "./actions";
import {
    selectDateFrom,
    selectDateTo,
    selectUsers,
    selectDashDetail,
    selectUsersRequesting,
    selectReportType,
    selectBar,
    selectVehicles,
    selectReportTitles,
    selectHolidayRequests,
    allReportTotals,
    selectReportsTotal,
    allReportsForTable,
    selectReportDataForExcel,
    selectBuildingExcelDocumentState
} from "./selectors";
import styles from "./styles";

class Dashboard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            report_type: "select_report",
            users: undefined,
            dateTo: Moment()._d,
            dateFrom: Moment("03052018", "DDMMYYYY")._d,
            excelReportType: ""
        };
        props.getUsers();
        props.getVehicles();
        props.setReportType("holiday");
        props.getReportTitles();
        props.getTotalUserReports();
        props.getTotalJobPackReports();
        loadCSS(
            "https://use.fontawesome.com/releases/v5.1.0/css/all.css",
            document.querySelector("#insertion-point-jss")
        );

        props.setDateFrom(this.state.dateFrom);
        props.setDateTo(this.state.dateTo);
    }
    componentDidMount() {}
    componentDidUpdate(prevProps, prevState) {
        if (this.state.index !== prevState.index) {
            this.props.setReportType("holiday");
        }
    }
    //Converts Object into Object Array to allow array mapping
    snapshotToArray(snapshot) {
        if (typeof snapshot !== "undefined")
            return Object.entries(snapshot).map(e => Object.assign(e[1], { key: e[0] }));
        else {
            return [];
        }
    }
    getTotVehicle() {
        if (typeof this.props.vehicles !== "undefined")
            return Object.keys(this.props.vehicles).length;
        else return 0;
    }
    getTotalfromArr(arr) {
        let total = 0;
        if (typeof arr !== "undefined")
            Object.keys(arr).map(i => {
                total += arr[i].total;
                return true;
            });
        return total;
    }
    render() {
        const { classes } = this.props;

        return (
            <div>
                <Grid container spacing={24}>
                    <Grid item xs={12} md={6} lg={3}>
                        <Paper className={classes.paper}>
                            <Card className={classes.card}>
                                <CardContent className={classes.content}>
                                    <div className={classNames(classes.cardTop, classes.colRed)}>
                                        <Icon
                                            className={classNames(
                                                classes.icon,
                                                "fas fa-user fa-5x"
                                            )}
                                        />
                                        <Typography variant="subheading" color="inherit">
                                            Total Employees
                                        </Typography>
                                    </div>
                                    <Typography variant="headline">
                                        {this.props.dashDetail.total_employees}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                        <Paper className={classes.paper}>
                            <Card className={classes.card}>
                                <CardContent className={classes.content}>
                                    <div className={classNames(classes.cardTop, classes.colGreen)}>
                                        <Icon
                                            className={classNames(
                                                classes.icon,
                                                "fas fa-shuttle-van fa-5x"
                                            )}
                                        />
                                        <Typography variant="subheading" color="inherit">
                                            Vehicles Registered
                                        </Typography>
                                    </div>
                                    <Typography variant="headline">
                                        {this.getTotVehicle()}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                        <Paper className={classes.paper}>
                            <Card className={classes.card}>
                                <CardContent className={classes.content}>
                                    <div className={classNames(classes.cardTop, classes.colBlue)}>
                                        <Icon
                                            className={classNames(
                                                classes.icon,
                                                "fas fa-file-contract fa-5x"
                                            )}
                                        />
                                        <Typography variant="subheading" color="inherit">
                                            Total Reports
                                        </Typography>
                                    </div>
                                    <Typography variant="headline">
                                        {this.props.reportTotal}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                        <Paper className={classes.paper}>
                            <Card className={classes.card}>
                                <CardContent className={classes.content}>
                                    <div className={classNames(classes.cardTop, classes.colOrange)}>
                                        <Icon
                                            className={classNames(
                                                classes.icon,
                                                "fas fa-plane-departure fa-5x"
                                            )}
                                        />
                                        <Typography variant="subheading" color="inherit">
                                            Total Holiday Requests
                                        </Typography>
                                    </div>
                                    <Typography variant="headline">
                                        {this.props.dashDetail.hol_total}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <Paper style={{ padding: 24 }} className={classes.paper}>
                            <Typography variant="title" style={{ paddingBottom: 24 }}>
                                Date Range Picker
                            </Typography>

                            <DayPickerInput
                                style={{ margin: 4 }}
                                value={this.state.dateFrom || ""}
                                placeholder="Single Date"
                                label="Single Date"
                                format="LL"
                                formatDate={formatDate}
                                parseDate={parseDate}
                                onDayChange={day => {
                                    this.props.setDateFrom(day);
                                    this.setState({ dateFrom: day });
                                }}
                            />

                            <DayPickerInput
                                style={{ margin: 4 }}
                                value={this.state.dateTo || ""}
                                label="End Date"
                                placeholder="End Date"
                                format="LL"
                                formatDate={formatDate}
                                parseDate={parseDate}
                                onDayChange={day => {
                                    this.props.setDateTo(day);
                                    this.setState({ dateTo: day });
                                }}
                            />

                            <Button
                                style={{
                                    marginLeft: "5px",
                                    marginTop: "-3px"
                                }}
                                color="primary"
                                variant="outlined"
                                onClick={() => {
                                    this.props.setDateFrom(false);
                                    this.props.setDateTo(false);
                                    this.setState({
                                        dateTo: "",
                                        dateFrom: ""
                                    });
                                }}
                            >
                                Clear Dates
                            </Button>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <Paper className={classes.paper}>
                            <Card>
                                <CardHeader title="All Report Total" />
                                <CardContent>
                                    <Bar
                                        height={200}
                                        options={{
                                            maintainAspectRatio: false,
                                            scales: {
                                                yAxes: [
                                                    {
                                                        ticks: {
                                                            beginAtZero: true
                                                        }
                                                    }
                                                ]
                                            }
                                        }}
                                        data={this.props.barData}
                                    />
                                </CardContent>
                            </Card>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <Paper className={classes.paper}>
                            <Card>
                                <CardContent>
                                    <div className={classes.tableWrapper}>
                                        <ReportTotalTable
                                            classes={classes}
                                            totalRep={this.props.totalRep}
                                            getTotalfromArr={this.getTotalfromArr}
                                        />
                                    </div>
                                </CardContent>
                            </Card>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <Paper className={classes.paper}>
                            <Card>
                                <CardContent>
                                    <div className={classes.tableWrapper}>
                                        <ReportTable
                                            classes={classes}
                                            reportTitles={this.props.reportTitles}
                                            reportsPerUser={this.props.reportsPerUser}
                                        />
                                    </div>
                                </CardContent>
                            </Card>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Paper className={classes.paper}>
                            <Card>
                                <CardHeader title="Download Reports As Excel" />
                                <CardContent>
                                    <FormControl
                                        style={{
                                            width: "100%"
                                        }}
                                    >
                                        <InputLabel>Please Select Report Type</InputLabel>
                                        <Select
                                            value={this.state.excelReportType}
                                            onChange={event => {
                                                this.setState({
                                                    excelReportType: event.target.value
                                                });
                                                this.props.setExcelReportType(event.target.value);
                                                this.props.getExcelReportTypeLabels(
                                                    event.target.value
                                                );
                                            }}
                                        >
                                            {this.props.reportTitles &&
                                                Object.keys(this.props.reportTitles).map((e, i) => {
                                                    return (
                                                        <MenuItem value={e} key={i}>
                                                            {this.props.reportTitles[e]}
                                                        </MenuItem>
                                                    );
                                                })}
                                        </Select>
                                    </FormControl>
                                    {this.props.selectedReports && (
                                        <Button
                                            style={{
                                                width: "100%",
                                                marginTop: "15px"
                                            }}
                                            variant="contained"
                                            color="primary"
                                            onClick={() => {
                                                this.props.getExcelDoc(
                                                    this.props.selectedReports,
                                                    this.state.excelReportType
                                                );
                                            }}
                                        >
                                            Download
                                        </Button>
                                    )}
                                </CardContent>
                            </Card>
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

export default connect(
    store => {
        return {
            users: selectUsers(store),
            usersRequesting: selectUsersRequesting(store),
            report_type: selectReportType(store),
            barData: selectBar(store),
            dashDetail: selectDashDetail(store),
            vehicles: selectVehicles(store),
            reportTitles: selectReportTitles(store),
            holReqs: selectHolidayRequests(store),
            totalRep: allReportTotals(store),
            profile: selectUserProfile(store),
            reportsPerUser: allReportsForTable(store),
            dateFrom: selectDateFrom(store),
            dateTo: selectDateTo(store),
            reportTotal: selectReportsTotal(store),
            selectedReports: selectReportDataForExcel(store),
            buildingState: selectBuildingExcelDocumentState(store)
        };
    },
    {
        setDateFrom,
        setDateTo,
        getUsers,
        setReportType,
        getVehicles,
        getReportTitles,
        getTotalUserReports,
        setExcelReportType,
        getTotalJobPackReports,
        getExcelReportTypeLabels,
        getExcelDoc
    }
)(withStyles(styles)(Dashboard));
